import { render, staticRenderFns } from "./invitedList.vue?vue&type=template&id=0cf09651&scoped=true"
import script from "./invitedList.vue?vue&type=script&lang=js"
export * from "./invitedList.vue?vue&type=script&lang=js"
import style0 from "./invitedList.vue?vue&type=style&index=0&id=0cf09651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf09651",
  null
  
)

export default component.exports